var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 14,
    viewBox: "0 0 26 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M0.440811 1.58929L7.39611 7.4L0.440811 13.2107C0.232152 13.385 0.232152 13.6949 0.440811 13.8693C0.64947 14.0436 1.02042 14.0436 1.22908 13.8693L8.55533 7.72927C8.67125 7.63243 8.71762 7.51621 8.71762 7.4C8.71762 7.28379 8.67125 7.16757 8.55533 7.07073L1.20589 0.930742C0.997235 0.756421 0.626286 0.756421 0.417627 0.930742C0.208968 1.10506 0.208967 1.41497 0.440811 1.58929Z",
    fill: "#EEE9FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.89442 1.58929L15.8497 7.4L8.89442 13.2107C8.68577 13.385 8.68577 13.6949 8.89442 13.8693C9.10308 14.0436 9.47403 14.0436 9.68269 13.8693L17.0089 7.72927C17.1249 7.63243 17.1712 7.51621 17.1712 7.4C17.1712 7.28379 17.1249 7.16757 17.0089 7.07073L9.65951 0.930742C9.45085 0.756421 9.0799 0.756421 8.87124 0.930742C8.66258 1.10506 8.66258 1.41497 8.89442 1.58929Z",
    fill: "#EEE9FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.3483 1.58929L24.3036 7.4L17.3483 13.2107C17.1396 13.385 17.1396 13.6949 17.3483 13.8693C17.5569 14.0436 17.9279 14.0436 18.1365 13.8693L25.4628 7.72927C25.5787 7.63243 25.6251 7.51621 25.6251 7.4C25.6251 7.28379 25.5787 7.16757 25.4628 7.07073L18.1134 0.930742C17.9047 0.756421 17.5338 0.756421 17.3251 0.930742C17.1164 1.10506 17.1164 1.41497 17.3483 1.58929Z",
    fill: "#EEE9FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThRightArrow);
export default __webpack_public_path__ + "static/media/th-right-arrow.a511b1a4b77ee3738dc596a6c387995d.svg";
export { ForwardRef as ReactComponent };